// extracted by mini-css-extract-plugin
export default {"button":"ButtonLike_button__8JOIv"};